import React, { createContext, useReducer } from "react";

import CreditNoteReportReducer from "../../reducers/reports/ipCreditNoteReportReducer";

import axios from "../../../axios";

const initialState = {
  loading: false,
  creditNotes: [],
  interpreters: [],
  totalAmount: 0,
  totalVAT: 0,
  totalCredit: 0,
  count: 0,
  error: null,
};

export const IPCreditNoteReportContext = createContext(initialState);

export const IPCreditNoteReportProvider = ({ children }) => {
  const [state, dispatch] = useReducer(CreditNoteReportReducer, initialState);

  // Get IP Credit Note Report
  const getCreditNoteReportHandler = async (filter) => {
    try {
      const result = await axios.get(
        `/api/v1/bookings/ip-credit-note-report?${filter}`,
      );

      dispatch({
        type: "FETCH_CREDIT_NOTE_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);

      dispatch({
        type: "PROCESS_ERROR",
        payload: error,
      });
    }
  };

  const getInterpretersHandler = async (fullname) => {
    try {
      const result = await axios.get(`/api/v1/interpreters?fname=${fullname}`);

      console.log("FULL INTERPRETER RESPONSE:", result);
      console.log("INTERPRETER RESULT DATA:", result.data);
      console.log("INTERPRETER RESULT DATA.DATA:", result.data?.data);

      dispatch({
        type: "FETCH_INTERPRETER_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error("INTERPRETER API ERROR:", error);
    }
  };

  // Clear State
  const clearCreditNoteStateHandler = () => {
    dispatch({
      type: "PROCESS_START",
    });
  };

  return (
    <IPCreditNoteReportContext.Provider
      value={{
        loading: state.loading,
        creditNotes: state.creditNotes,
        interpreters: state.interpreters,
        totalAmount: state.totalAmount,
        totalVAT: state.totalVAT,
        totalCredit: state.totalCredit,
        count: state.count,

        getCreditNoteReportHandler,
        getInterpretersHandler,
        clearCreditNoteStateHandler,

        error: state.error,
      }}
    >
      {children}
    </IPCreditNoteReportContext.Provider>
  );
};
